import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'

const LogoutPage = () => {
  const { t } = useTranslation('auth')
  const navigate = useNavigate()
  const { logout } = useAuth()
  const [error, setError] = useState(null)

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Use AuthContext's logout to ensure state is properly cleared
        await logout()

        // Brief delay to show the logout message
        setTimeout(() => {
          // Redirect to login page
          navigate('/login', { replace: true })
        }, 1000)
      } catch (err) {
        console.error('Logout error:', err)
        setError(t('logout.errorMessage'))

        setTimeout(() => {
          navigate('/login', { replace: true })
        }, 2000)
      }
    }

    performLogout()
  }, [navigate, logout, t])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center',
        minWidth: '300px'
      }}>
        {error ? (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
            <h2 style={{ color: '#d32f2f', marginBottom: '0.5rem' }}>{t('logout.issueTitle')}</h2>
            <p style={{ color: '#666' }}>{error}</p>
          </>
        ) : (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>👋</div>
            <h2 style={{ color: '#333', marginBottom: '0.5rem' }}>{t('logout.title')}</h2>
            <p style={{ color: '#666' }}>{t('logout.message')}</p>
            <div style={{
              marginTop: '1.5rem',
              width: '100%',
              height: '4px',
              backgroundColor: '#e0e0e0',
              borderRadius: '2px',
              overflow: 'hidden'
            }}>
              <div style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#1976d2',
                animation: 'progress 1s ease-in-out'
              }} />
            </div>
          </>
        )}
      </div>
      <style>{`
        @keyframes progress {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </div>
  )
}

export default LogoutPage
